exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container--vAKZK{margin-bottom:24px}\n", "", {"version":3,"sources":["/workspace/src/widget/event_components/Ticket/components/AccessCode/access-code.scss"],"names":[],"mappings":"AAAA,kBACE,kBAAmB,CAAA","file":"access-code.scss","sourcesContent":[".container {\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container--vAKZK"
};